import { Icon } from './types';

export const Badge = ({ svgProps, pathProps }: Icon) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="17"
    fill="none"
    data-testid="badge"
    {...svgProps}
  >
    <path
      fill="#000"
      d="M1.333 7.06v1.166h9.334V7.059H1.333Zm0-6.418h9.334c.32 0 .595.117.822.345.228.227.344.501.344.822v6.417c0 .32-.116.595-.344.822a1.124 1.124 0 0 1-.822.344H8.333v2.917L6 11.143l-2.333 1.166V9.392H1.333c-.32 0-.595-.116-.822-.344a1.124 1.124 0 0 1-.344-.822V1.809c0-.32.116-.595.344-.822.227-.228.501-.345.822-.345Zm0 4.667h9.334v-3.5H1.333v3.5Z"
      {...pathProps}
    />
  </svg>
);
